import React from 'react';
import './style.css'; // Assuming you have similar styles for Dropdown like TextInput
import LabelSpan from '../LabelSpan';

export default function Dropdown({
    label,
    className,
    value,
    onChange,
    disabled,
    children
}) {
    const selectLabel = label ? <LabelSpan>{label}</LabelSpan> : null;

    return (
        <label>
            {selectLabel}
            <div className="select-wrapper">
                <select
                    className={`${className}`}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                >
                    {children}
                </select>
            </div>
        </label>
    );
}
